/**
 * Collection of design tokens representing different levels of transparency. These tokens can be
 * used to modulate the visibility of elements and text.
 */ const opacities = {
    none: 0,
    placeholder: 0.4,
    weaker: 0.5,
    weak: 0.6,
    medium: 0.7,
    strong: 0.8,
    stronger: 0.9,
    full: 1
};

export { opacities };
//# sourceMappingURL=opacities.js.map
